import React from 'react'
import { useField, useFormikContext } from 'formik'

import { StepContainer } from '../StepContainer'
import { BrandCardList, IBrand } from '../steps/Brand/BrandCardList'
import { Confirm } from '../steps/Confirm/Confirm'
import { ModelList } from '../steps/Model/ModelList'
import { VehicleTypeList } from '../steps/Type/VehicleTypeList'
import { IModel, IVehicleType } from '@cbgms/api'
import { useGetAllSelectionAttributes } from './hooks/useGetAllSelectionAttributes'
import { StepOption, useSelectionContext } from '../../context/SelectionContext'
import BrandLoader from '../steps/Loader/BrandLoader'
import { TypeListLoader } from '../steps/Loader/TypeLoader'
import { ModelListLoader } from '../steps/Loader/ModelLoader'
import { useShopCountry } from '@cbgms/base/shop-country'
import { FieldName_Provider } from 'app/vehicles/components/UnknownVehicleV2/components/providers/const'

export const MMT: React.FC<{ slotBottomButtons?: React.ReactNode }> = ({ slotBottomButtons }) => {
  const { currentStep, setBrand, brand, setModel, model, setType } = useSelectionContext()
  const { setFieldValue } = useFormikContext()
  const [{ value: provider }] = useField(FieldName_Provider)
  const { country } = useShopCountry()

  const { brands, models, types, isLoading } = useGetAllSelectionAttributes(currentStep, provider, country!, brand?.value, model?.key)

  const onBrandSelect = (key: string, brand: IBrand) => {
    setBrand({ key, value: brand.value, name: brand.name })
    setFieldValue('vehicle', { Manufacturer: brand.name, ManufacturerID: key })
  }
  const onModelSelect = (key: string, model: IModel) => {
    setModel({ key, value: model, name: model.ModelName })
    setFieldValue('vehicle', {
      Manufacturer: brand?.name,
      ManufacturerID: brand?.key,
      Model: model.ModelName,
      ModelID: key
    })
  }
  const onTypeSelect = (type: IVehicleType) => {
    setType({ key: type.Type, value: type, name: type.Type })
    setFieldValue('vehicle', { ...type, Manufacturer: brand?.key, ManufacturerID: brand?.key, ModelID: model?.key, Model: model?.name })
  }

  return (
    <StepContainer>
      <SelectionSteps
        currentStep={currentStep}
        onBrandSelect={onBrandSelect}
        onModelSelect={onModelSelect}
        onTypeSelect={onTypeSelect}
        brands={brands!}
        models={models!}
        types={types!}
        isLoading={isLoading}
        slotBottomButtons={slotBottomButtons}
      />
    </StepContainer>
  )
}

interface SelectionStepProps {
  currentStep: StepOption
  brands: IBrand[]
  models: IModel[]
  types: IVehicleType[]
  onBrandSelect: (key: string, value: IBrand) => void
  onModelSelect: (key: string, value: IModel) => void
  onTypeSelect: (value: IVehicleType) => void
  isLoading: boolean
  slotBottomButtons?: React.ReactNode
}

const SelectionSteps: React.FC<SelectionStepProps> = ({
  currentStep,
  brands,
  onBrandSelect,
  models,
  onModelSelect,
  types,
  onTypeSelect,
  isLoading,
  slotBottomButtons
}) => {
  if (currentStep === StepOption.BRAND) {
    return isLoading ? <BrandLoader /> : <BrandCardList brands={brands} onBrandSelect={onBrandSelect} />
  }
  if (currentStep === StepOption.MODEL) {
    return isLoading ? <ModelListLoader /> : <ModelList models={models} onModelSelect={onModelSelect} />
  }
  if (currentStep === StepOption.TYPE) {
    return isLoading ? <TypeListLoader /> : <VehicleTypeList types={types} onTypeSelect={onTypeSelect} />
  }
  if (currentStep === StepOption.CONFIRM) {
    return <Confirm slotBottomButtons={slotBottomButtons} />
  }
  return null
}
